import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "DISCONNECTED", // DISCONNECTED | CONNECTING | WAITING | NEGOTIATING | CONNECTED | ACTIVE | WARNING | ENDED
  appointmentId: null,
  role: null, // CUSTOMER | COACH
  otherPresent: false,
  localStream: null,
  remoteStream: null,
  isMicMuted: false,
  isCameraOff: false,
  timeRemaining: null, // seconds
  warningShown: false,
  endReason: null,
  actualDurationSeconds: null,
  actualEndTime: null,
  error: null,
};

const meetingSlice = createSlice({
  name: "meeting",
  initialState,
  reducers: {
    setMeetingStatus(state, action) {
      state.status = action.payload;
    },
    setAppointmentId(state, action) {
      state.appointmentId = action.payload;
    },
    setRole(state, action) {
      state.role = action.payload;
    },
    setOtherPresent(state, action) {
      state.otherPresent = action.payload;
    },
    setLocalStream(state, action) {
      state.localStream = action.payload;
    },
    setRemoteStream(state, action) {
      state.remoteStream = action.payload;
    },
    setMicMuted(state, action) {
      state.isMicMuted = action.payload;
    },
    setCameraOff(state, action) {
      state.isCameraOff = action.payload;
    },
    setTimeRemaining(state, action) {
      state.timeRemaining = action.payload;
    },
    showWarning(state) {
      state.warningShown = true;
      if (state.status === "ACTIVE" || state.status === "CONNECTED") {
        state.status = "WARNING";
      }
    },
    meetingEnded(state, action) {
      state.status = "ENDED";
      state.endReason = action.payload.reason;
      state.actualDurationSeconds = action.payload.actualDurationSeconds;
      state.actualEndTime = action.payload.actualEndTime;
      state.warningShown = false;
    },
    resetMeeting(state) {
      return { ...initialState };
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const {
  setMeetingStatus,
  setAppointmentId,
  setRole,
  setOtherPresent,
  setLocalStream,
  setRemoteStream,
  setMicMuted,
  setCameraOff,
  setTimeRemaining,
  showWarning,
  meetingEnded,
  resetMeeting,
  setError,
} = meetingSlice.actions;

export default meetingSlice.reducer;
